(ns common.schema.entities.declaration
  (:require
   [common.schema.schema-utils :as su]
   [common.schema.entities.common :as common]))

(def schema
  (vec
   (concat

    (su/boolean-field :declaration/draft?
                      "Draft"
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use-disabled})

    (su/boolean-field :declaration/not-applicable?
                      "Not applicable"
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use-disabled})

    (su/boolean-field :declaration/completed?
                      "Completed"
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use-disabled})

    (su/text-multiline-field :declaration/comment
                             "Comment"
                             {:authorization            su/access-user-user
                              :hidden-from-config?      true
                              :default-field-visibility :not-in-use})

    (su/date-field :declaration/date
                   "Date"
                   {:authorization            su/access-user-user
                    :hidden-from-config?      true
                    :default-field-visibility :not-in-use})

    common/attachment-schema)))

(def required-fields
  #{})
